import Delta from 'quill-delta';

export function collectUsedKeys(q: Delta): Set<string> {
    const used = new Set<string>();
    q.ops.forEach((op: any) => {
        const k = op?.attributes?.key
        if (k) {
            used.add(k)
        }
    })

    return used;
}

export function generateUniqueRandomKey(used: Set<string>): string {
    let candidate = Math.floor(Math.random() * 1_000_000_000) + 1;
    while (used.has(candidate.toString())) {
        candidate = Math.floor(Math.random() * 1_000_000_000) + 1;
    }

    return candidate.toString()
}

// export function getNextKey(q: any): number {
//     const used = collectUsedKeys(q);
//     return generateUniqueRandomKey(used);
// }